import {
  put, takeLatest, all, call, select, takeEvery,
} from 'redux-saga/effects';
import { message } from 'antd';
import {
  LENTES_PEL_FORMULARIO_INICIALIZAR, LENTES_PEL_GET_COLORES_LENTE_REQUEST,
  LENTES_PEL_GET_COLORES_REQUEST, LENTES_PEL_GET_COLORES_SUCCESS, LENTES_PEL_GET_DIAMETROS_POSIBLES_REQUEST,
  LENTES_PEL_GET_FABRICANTES_REQUEST,
  LENTES_PEL_GET_INDICES_REQUEST, LENTES_PEL_GET_INDICES_SUCCESS,
  LENTES_PEL_GET_LENTES_LIST_REQUEST,
  LENTES_PEL_GET_LENTESTIPOSPVP_REQUEST, LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS,
  LENTES_PEL_GET_ORDEN_GRADUACION_REQUEST,
  LENTES_PEL_GET_PASILLOS_REQUEST,
  LENTES_PEL_GET_PASILLOS_SUCCESS, LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_REQUEST,
  LENTES_PEL_MIS_CATALOGOS_FAILURE,
  LENTES_PEL_MIS_CATALOGOS_REQUEST,
  LENTES_PEL_MIS_CATALOGOS_SUCCESS, LENTES_PEL_OBTENER_DATOS_LENTES, LENTES_PEL_PROCESS_FINAL_SELECTION,
  LENTES_PEL_SELECCION_COLOR,
  LENTES_PEL_SELECCION_FABRICANTE,
  LENTES_PEL_SELECCION_GRADUACION,
  LENTES_PEL_SELECCION_GRADUACION_GENERICA, LENTES_PEL_SELECCION_INDICE,
  LENTES_PEL_SELECCION_LENTE_TIPO_PVP,
  LENTES_PEL_SELECCION_PASILLO, LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO,
  LENTES_PEL_SET_DIAMETRO_MINIMO, LENTES_PEL_SET_FUERA_NORMA, LENTES_PEL_SET_SEARCH_VALUE,
} from '../actions/constants/pel.constants';
import { authRequest } from '../../helpers/request.helper';
import {
  cargarMisCatalogos,
  obtenerColoresSuccessAction,
  obtenerColoresFailureAction,
  establecerOpcionesFormularioPanel,
  restablecerFiltro,
  getMisFabricantesSuccessAction,
  getMisFabricantesFailureAction,
  getLentesListSuccessAction,
  getLentesListFailureAction,
  getMisPasillosSuccessAction,
  getMisPasillosFailureAction,
  getMisIndicesFailureAction,
  getMisIndicesSuccessAction,
  setInicializado,
  getLentesListRequest,
  getLentesTiposPvpsSuccesAction,
  getLentesTiposPvpsFailureAction,
  getOrdenGraduacionSuccessAction,
  getOrdenGraduacionFailureAction,
  getDiametrosPosiblesSuccessAction,
  getDiametrosPosiblesFailureAction,
  setSelecccionLente,
  getColoresLenteSuccessAction,
  getColoresLenteFailureAction,
  getColoresLenteRequest,
  getDiametrosPosiblesRequest,
  setFinalSelection,
  setErrorSeleccionLente,
  establecerDnpObligatorio,
  getTratamientosPosiblesSuccessAction,
  getTratamientosPosiblesFailureAction,
  getTratamientosPosiblesRequest, clearLentesListAction,
} from '../actions/creators/pel.actioncreator';
import { sendSetTilteGW1 } from '../../helpers/GW1sendMessage.helper';
import {
  comprobarDatosSeleccionLente, formatearDatosGraduacion,
  formatearDatosLenteEncargosPel,
  formatearDatosSeleccionPel,
  tieneRestriccionCliente,
} from '../../helpers/modules/pel.helper';


const pelItems = state => state.pel;
const userData = state => state.auth.user;
const permisosData = state => state.auth.permisos;


function* obtenerFitrosFromDB() {
  const pel = yield select(pelItems);
  const formData = new FormData();
  const { filtrador: { selecciones: { graduacion } }, viene_de } = pel;
  formData.append('graduacion', JSON.stringify(graduacion));
  formData.append('viene_de', viene_de);
  try {
    const params = {
      url: 'api/pel/filtros/buscar',
      method: 'POST',
      body: formData,
    };
    const datos = yield call(authRequest, params);
    yield put(establecerDnpObligatorio(datos && datos.dnpObligatorio));
    yield put(cargarMisCatalogos(datos));
    yield put({ type: LENTES_PEL_MIS_CATALOGOS_SUCCESS });
    const { focos, catalogo } = datos;
    if (catalogo) {
      yield put(establecerOpcionesFormularioPanel({ panel: 'catalogo', opciones: catalogo }));
    }
    if (focos) {
      yield put(establecerOpcionesFormularioPanel({ panel: 'focos', opciones: focos }));
    }
  } catch (error) {
    yield put({ type: LENTES_PEL_MIS_CATALOGOS_FAILURE });
  }
}

function* inicializarFormulario() {
  const pel = yield select(pelItems);
  const { misCatalogos: { focos, catalogo }, inicializado } = pel;
  if (!inicializado) {
    yield put(establecerOpcionesFormularioPanel({ panel: 'catalogo', opciones: catalogo }));
    yield put(establecerOpcionesFormularioPanel({ panel: 'focos', opciones: focos }));
    yield put(restablecerFiltro());
  } else {
    yield put(setInicializado(false));
  }
}

function* obtenerDatosLente({ payload }) {
  const { filtrador, modoNoPel } = yield select(pelItems);
  const permisos = yield select(permisosData);
  const { lentes } = filtrador;
  const trabajaConColores = permisos && permisos.configuracion.micatalogo_colores_personalizados !== 'N';
  if (trabajaConColores && (!lentes[payload] || (lentes[payload].colores.length > 0 && lentes[payload].colores[0].tipoId !== ''))) {
    //yield put(setSelecccionLente(payload));
    //return;
  }
  if (modoNoPel || !trabajaConColores) {
    yield put(getColoresLenteRequest(payload));
  }
  if (modoNoPel) {
    yield put(getDiametrosPosiblesRequest(payload));
    yield put(getTratamientosPosiblesRequest(payload));
  } else {
    yield put(getDiametrosPosiblesRequest(payload));
  }
  yield put(setSelecccionLente(payload));
}
function* obtenerColores({ payload }) {
  try {
    const formData = new FormData();
    const user = yield select(userData);
    const pel = yield select(pelItems);
    const permisos = yield select(permisosData);
    const { filtrador: { selecciones: { graduacion: { generico } } }, modo } = pel;
    // const focoIdGenerico = generico && generico.ADD && generico.ADD !== '' ? 2 : 1;
    formData.append('data', JSON.stringify({ ...payload, modo }));
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/MisColores/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, params);
    yield put(obtenerColoresSuccessAction(response, modo, permisos && permisos.configuracion.micatalogo_colores_personalizados !== 'N'));
  } catch (error) {
    yield put(obtenerColoresFailureAction(error));
  }
}
function* getColoresLenteList({ payload }) {
  try {
    const { filtrador, modo, modoNoPel } = yield select(pelItems);
    const { selecciones, lentes } = filtrador;
    const formData = new FormData();
    const user = yield select(userData);
    const permisos = yield select(permisosData);
    const trabajaConColores = permisos && permisos.configuracion.micatalogo_colores_personalizados !== 'N';
    if (!modoNoPel && trabajaConColores) return;
    const {
      miColor, focos,
      montura, catalogo, miFabricante,
    } = selecciones;
    const lentesKeys = Object.keys(lentes);
    let lente = null;
    for (let i = 0; i < lentesKeys.length; i++) {
      const lenteI = lentes[lentesKeys[i]];
      if (lenteI.key === payload) lente = lenteI;
    }
    formData.append('data', JSON.stringify({
      miColor,
      miFabricante,
      catalogo,
      montura,
      focos,
      lente,
      modo,
    }));
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/lenteColores/buscar',
      method: 'POST',
      body: formData,
    };
    const colores = yield call(authRequest, params);

    yield put(getColoresLenteSuccessAction(lente, colores));
  } catch (error) {
    yield put(getColoresLenteFailureAction(error));
  }
}
function* obtenerOrdenGraduacion() {
  try {
    const formData = new FormData();
    const user = yield select(userData);
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/graduacion/orden',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, params);
    yield put(getOrdenGraduacionSuccessAction(response));
  } catch (error) {
    yield put(getOrdenGraduacionFailureAction(error));
  }
}
function* obtenerFabricantes() {
  try {
    const formData = new FormData();
    const pel = yield select(pelItems);
    const { modoNoPel } = pel;
    const user = yield select(userData);
    formData.append('user', JSON.stringify(user));
    formData.append('modoNoPel', modoNoPel);
    const params = {
      url: 'api/pel/MisFabricantes/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, params);
    yield put(getMisFabricantesSuccessAction(response));
  } catch (error) {
    yield put(getMisFabricantesFailureAction(error));
  }
}
function* obtenerLentesTiposPvps() {
  try {
    const formData = new FormData();
    const user = yield select(userData);
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/lentesTiposPvp/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, params);
    yield put(getLentesTiposPvpsSuccesAction(response));
  } catch (error) {
    yield put(getLentesTiposPvpsFailureAction(error));
  }
}
function* obtenerPasillos() {
  try {
    const formData = new FormData();
    const user = yield select(userData);
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/pasillos/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, params);
    yield put(getMisPasillosSuccessAction(response));
  } catch (error) {
    yield put(getMisPasillosFailureAction(error));
  }
}
function* obtenerIndices() {
  try {
    const pel = yield select(pelItems);
    const { filtrador: { selecciones: { focos, categorias, colores, graduacion: { generico } } }, modo, modoNoPel } = pel;
    const formData = new FormData();
    const user = yield select(userData);
    const focoIdGenerico = generico && generico.ADD && generico.ADD !== '' ? 2 : 1;
    formData.append('user', JSON.stringify(user));
    formData.append('data', JSON.stringify({
      categoria: categorias, color: colores, modo, focoIdGenerico, usaMiCatalogo: !modoNoPel, focos,
    }));
    const params = {
      url: 'api/pel/indices/buscar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(authRequest, params);
    yield put(getMisIndicesSuccessAction(response));
    // yield put(getLentesListRequest(response));
  } catch (error) {
    yield put(getMisIndicesFailureAction(error));
  }
}
function* processLenteFinalSelection({ payload: { callback, usaVentanaTrazadora, pedirSuplementos } }) {
  const pel = yield select(pelItems);
  const permisos = yield select(permisosData);
  const trabajaConColores = permisos && permisos.configuracion.micatalogo_colores_personalizados !== 'N';
  const alturafocalObligatoria = permisos && permisos.configuracion.obligatorio_altura_focal == 1;
  const errorSeleccion = comprobarDatosSeleccionLente(pel, usaVentanaTrazadora, trabajaConColores, alturafocalObligatoria);
  yield put(setErrorSeleccionLente(errorSeleccion));
  if (errorSeleccion) {
    if (errorSeleccion) message.error(errorSeleccion.message);
    return;
  }
  const datosSeleccionLente = formatearDatosSeleccionPel(pel, usaVentanaTrazadora, trabajaConColores);
  let datosCallback = datosSeleccionLente;

  if (pedirSuplementos) {
    const formDataSuplementos = new FormData();
    const formDataMaterialesBiselado = new FormData();
    formDataSuplementos.append('data', JSON.stringify(datosSeleccionLente));
    formDataSuplementos.append('obligatorios', !usaVentanaTrazadora);
    const paramsObtenerSuplementos = { url: 'api/pel/suplementos/obtener', method: 'POST', body: formDataSuplementos };
    formDataMaterialesBiselado.append('data', JSON.stringify(datosSeleccionLente));
    const paramsObtenerMaterialesBiselado = { url: 'api/pel/biselado/materialesYbisel', method: 'POST', body: formDataMaterialesBiselado };
    try {
      yield put({
        type: 'OBTENER_SUPLEMENTOS_LENTE_REQUEST',
      });
      const resultadoSuplementos = yield call(authRequest, paramsObtenerSuplementos);
      yield put({
        type: 'OBTENER_SUPLEMENTOS_LENTE_SUCCESS',
        payload: resultadoSuplementos,
      });
      const lentes = formatearDatosLenteEncargosPel(datosSeleccionLente, resultadoSuplementos);
      datosCallback = {
        lentes, datosSeleccionLente, resultadoSuplementos, usaVentanaTrazadora,
      };
    } catch (e) {
      yield put({ type: 'OBTENER_SUPLEMENTOS_LENTE_FAILURE', payload: e });
    }
    try {
      yield put({
        type: 'OBTENER_MATERIALES_BISELADO_LENTE_REQUEST',
      });
      const resultadoMaterialesBiselado = yield call(authRequest, paramsObtenerMaterialesBiselado);
      yield put({
        type: 'OBTENER_MATERIALES_BISELADO_LENTE_SUCCESS',
        payload: resultadoMaterialesBiselado,
      });

      datosCallback.materialesYBiselados = resultadoMaterialesBiselado;
    } catch (e) {
      yield put({ type: 'OBTENER_MATERIALES_BISELADO_LENTE_FAILURE', payload: e });
    }
  }
  yield put(setFinalSelection(datosCallback));
  if (typeof callback === 'function') {
    yield call(callback, datosCallback);
  }
}
function* setTitleGw1({ payload }) {
  const { modo, filtrador: { selecciones } } = yield select(pelItems);
  const { caracteristica, valorSeleccionado } = payload;
  const { id: idCaracteristica, multiselect } = caracteristica;
  const { focos } = selecciones;
  if ((idCaracteristica !== 'focos' && idCaracteristica !== 'colores') || modo === 'consulta') return;
  let title = 'Selección de lentes';
  switch (idCaracteristica === 'focos' ? valorSeleccionado.valor : focos.valor) {
    case 0:
      title += ': Monofocal';
      break;
    case 1:
      title += ': Monofocal';
      break;
    case 2:
      title += ': Monofocal';
      break;
    case 3:
      title += ': Progresiva';
      break;  
    case 4:
      title += ': Bifocales y media distancia';
      break;
  }
  if (idCaracteristica === 'colores') {
    title += ` / ${valorSeleccionado.gama_color}`;
  }
  yield call(sendSetTilteGW1, { title });
}
function* doLentesListRequest() {
  const {
    filtrador,
  } = yield select(pelItems);
  const { selecciones, parametrosMonturaEsablecidos, barraBusqueda } = filtrador;
  const {
    montura: { diametroMinimo },
  } = selecciones;
  const sinDiametroMinimo = !diametroMinimo || diametroMinimo === '';
  if (sinDiametroMinimo) return;
  yield put(clearLentesListAction());
  yield put(getLentesListRequest({ pagina: 1, textoBusqueda: barraBusqueda.value }));
}
function* getLentesList({ payload }) {
  try {
    const {
      filtrador, modo, usaMiCatalogo, modoNoPel, numPack, packId, tienePromocion, packPromocional,
      linea,
    } = yield select(pelItems);
    const { selecciones, parametrosMonturaEsablecidos, fueraDeNorma } = filtrador;
    const formData = new FormData();
    const user = yield select(userData);
    const permisos = yield select(permisosData);
    const trabajaConColores = permisos && permisos.configuracion.micatalogo_colores_personalizados !== 'N';
    const {
      indices, graduacion, miColor, miFabricante, categorias, montura, focos, pasillos, lenteTipoPvp,
      montura: { diametroMinimo }, catalogo, tratamientos, colores,
    } = selecciones;
    const {
      generico,
    } = graduacion;
    const { ADD } = generico;
    const { AXIS } = generico;
    const { CIL } = generico;
    const { ESF } = generico;
    const sinDiametroMinimo = !diametroMinimo || diametroMinimo === '';
    const usaMiCatalogoIndices = modoNoPel ? 0 : 1;
    if (!pasillos || pasillos.length === 0) return;
    if (!indices || !graduacion || (!miFabricante && modoNoPel)) {
      yield put(getLentesListSuccessAction([]));
      return;
    }
    if (modo === 'consulta' && ((!lenteTipoPvp && !modoNoPel) || sinDiametroMinimo || !graduacion.generico || !miFabricante || ((ESF === null || ESF === '') && ((AXIS === null || AXIS === '') || (CIL === null || CIL === ''))))) {
      yield put(getLentesListSuccessAction([]));
      return;
    }
    if (sinDiametroMinimo) {
      yield put(getLentesListSuccessAction([]));
      return;
    }
    if (modo !== 'consulta' && trabajaConColores && !modoNoPel && colores !== undefined && colores !== null && miColor === null) {
      yield put(getLentesListSuccessAction([]));
      return;
    }
    if (!parametrosMonturaEsablecidos && sinDiametroMinimo) {
      yield put(getLentesListSuccessAction([]));
      return;
    }
    const indicesUsados = indices.filter(e => e.esMiCatalogo === usaMiCatalogoIndices && e.isSelected);
    const indicesKeys = Object.keys(indicesUsados);
    if (indicesKeys.length === 0
      || (modo !== 'consulta' && !graduacion.izquierdo && !graduacion.derecho)
      || (modo === 'consulta' && !graduacion.generico)) {
      yield put(getLentesListSuccessAction([]));
      return;
    }
    const tieneIndiceOtros = indices.find(e => e.id === -1 && e.isSelected);
    /*
    const selectedGrosores = [];
    indicesKeys.forEach((key) => {
      if (indices[key].isSelected) selectedGrosores.push(indices[key]);
    });
    */
    const selectedGraduaciones = [];
    if (graduacion.izquierdo && graduacion.izquierdo.isSelected) {
      selectedGraduaciones.push(graduacion.izquierdo);
    }
    if (graduacion.derecho && graduacion.derecho.isSelected) {
      selectedGraduaciones.push(graduacion.derecho);
    }
    if (modo === 'consulta' && graduacion.generico) {
      selectedGraduaciones.push(graduacion.generico);
    }
    if (modo !== 'consulta' && (indices.length === 0 || selectedGraduaciones.length === 0)) {
      yield put(getLentesListSuccessAction([]));
      return;
    }
    let categoria = categorias;
    if (modo === 'consulta') {
      categoria = { clasificacion_foco_id: ADD !== '' && ADD !== null ? 2 : 1 };
    }
    const selectedPasillo = pasillos.find(pasillo => pasillo.isSelected);
    let textoABuscar = payload?.textoBusqueda;
    if (textoABuscar && textoABuscar !== '') {
      textoABuscar = `%${textoABuscar}%`;
    }
    formData.append('data', JSON.stringify({
      textoBusqueda: textoABuscar,
      pagina: !modoNoPel ? 0 : payload?.pagina,
      indices: tieneIndiceOtros ? null : indicesUsados,
      graduaciones: selectedGraduaciones.map(e => (e.transposicion ? e.transposicion : e)),
      pasillo: selectedPasillo,
      miColor,
      colores,
      miFabricante,
      catalogo,
      montura,
      focos,
      categoria,
      lenteTipoPvp,
      tratamiento: tratamientos,
      usaMiCatalogo,
      modo,
      numPack,
      packId,
      linea,
      tienePromocion,
      fueraDeNorma,
    }));
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/MisLentes/buscar',
      method: 'POST',
      body: formData,
    };
    const lentes = yield call(authRequest, params);
    if (tienePromocion && packPromocional && packPromocional.datosPadrino) {
      const restriccionesKeys = Object.keys(packPromocional.relacion.restricciones);
      restriccionesKeys.forEach((key) => {
        const restriccion = packPromocional.relacion.restricciones[key];
        switch (restriccion.idrestriccion) {
          case '1':
            const restriccionCliente = tieneRestriccionCliente(restriccion, packPromocional.datosPadrino);
            const lentePadrino = packPromocional.datosPadrino.lente;
            if (restriccionCliente) {
              Object.keys(lentes).forEach((lenteKey) => {
                /*
                const tratamientosFiltrados = lentes[lenteKey].tratamientos.filter(tratamiento => tratamiento.precioPack1 < lentePadrino.precio);
                if (tratamientosFiltrados.length === 0) {
                  delete lentes[lenteKey];
                } else {
                  lentes[lenteKey].tratamientos = tratamientosFiltrados;
                }

                */
                lentes[lenteKey].tratamientos = lentes[lenteKey].tratamientos.map(tratamiento => (
                  { ...tratamiento, tieneRestriccionPrecio: tratamiento.precioPack1 > lentePadrino.precio }
                ));
              });
            }
            break;
          default:
            break;
        }
      });
    }

    const lentesKeys = Object.keys(lentes);
    for (let i = 0; i < lentesKeys.length; i++) {
      const lente = lentes[lentesKeys[i]];
      lente.tratamientos.sort((a, b) => b.precio - a.precio);
      const vieneSeleccionado = lente.tratamientos.find(e => e.isSelected === true);
      if (vieneSeleccionado === undefined || vieneSeleccionado === null) {
        const tratamientoSeleccionado = lente.tratamientos[lente.tratamientos.length - 1];
        tratamientoSeleccionado.isSelected = true;
        lente.diametrosSeleccionados = { I: tratamientoSeleccionado.diametros.I[0], D: tratamientoSeleccionado.diametros.D[0] };
      } else {
        lente.diametrosSeleccionados = { I: vieneSeleccionado.diametros.I[0], D: vieneSeleccionado.diametros.D[0] };
      }
      lente.colores[0].isSelected = true;
    }

    yield put(getLentesListSuccessAction(lentes));
  } catch (error) {
    yield put(getLentesListFailureAction(error));
  }
}
function* getDiametrosPosibles({ payload }) {
  try {
    const { filtrador, modo, modoNoPel } = yield select(pelItems);
    const { selecciones, lentes } = filtrador;
    const formData = new FormData();
    const user = yield select(userData);
    //if (!modoNoPel) return;
    const {
      indices, graduacion, miColor, miFabricante, focos, pasillos, lenteTipoPvp,
      montura, catalogo, tratamientos,
    } = selecciones;
    const selectedGraduaciones = [];
    if (graduacion.izquierdo && graduacion.izquierdo.isSelected) {
      selectedGraduaciones.push(graduacion.izquierdo.transposicion);
    }
    if (graduacion.derecho && graduacion.derecho.isSelected) {
      selectedGraduaciones.push(graduacion.derecho.transposicion);
    }
    if (modo === 'consulta' && graduacion.generico) {
      selectedGraduaciones.push(graduacion.generico);
    }
    const lentesKeys = Object.keys(lentes);
    let lente = null;
    for (let i = 0; i < lentesKeys.length; i++) {
      const lenteI = lentes[lentesKeys[i]];
      if (lenteI.key === payload) lente = lenteI;
    }
    formData.append('data', JSON.stringify({
      indices,
      graduaciones: selectedGraduaciones,
      miColor,
      miFabricante,
      catalogo,
      montura,
      focos,
      lenteTipoPvp,
      tratamiento: tratamientos,
      lente,
      modo,
    }));
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/MiLenteDiametros/buscar',
      method: 'POST',
      body: formData,
    };
    const diametrosPosiblesLente = yield call(authRequest, params);

    yield put(getDiametrosPosiblesSuccessAction(lente, diametrosPosiblesLente));
  } catch (error) {
    yield put(getDiametrosPosiblesFailureAction(error));
  }
}

function* getTratamientosPosibles({ payload }) {
  try {
    const { filtrador, modo, modoNoPel } = yield select(pelItems);
    const { selecciones, lentes } = filtrador;
    const formData = new FormData();
    const user = yield select(userData);
    if (!modoNoPel) return;
    const {
      indices, graduacion, miColor, miFabricante, focos, pasillos, lenteTipoPvp,
      montura, catalogo, tratamientos,
    } = selecciones;
    const selectedGraduaciones = [];
    if (graduacion.izquierdo && graduacion.izquierdo.isSelected) {
      selectedGraduaciones.push(graduacion.izquierdo);
    }
    if (graduacion.derecho && graduacion.derecho.isSelected) {
      selectedGraduaciones.push(graduacion.derecho);
    }
    if (modo === 'consulta' && graduacion.generico) {
      selectedGraduaciones.push(graduacion.generico);
    }
    const lentesKeys = Object.keys(lentes);
    let lente = null;
    for (let i = 0; i < lentesKeys.length; i++) {
      const lenteI = lentes[lentesKeys[i]];
      if (lenteI.key === payload) lente = lenteI;
    }
    formData.append('data', JSON.stringify({
      indices,
      graduaciones: selectedGraduaciones,
      miColor,
      miFabricante,
      catalogo,
      montura,
      focos,
      lenteTipoPvp,
      tratamiento: tratamientos,
      lente,
      modo,
    }));
    formData.append('user', JSON.stringify(user));
    const params = {
      url: 'api/pel/tratamientos/buscar',
      method: 'POST',
      body: formData,
    };
    const diametrosPosiblesLente = yield call(authRequest, params);

    yield put(getTratamientosPosiblesSuccessAction(lente, diametrosPosiblesLente));
  } catch (error) {
    yield put(getTratamientosPosiblesFailureAction(error));
  }
}
function* pelSaga() {
  yield all([
    takeLatest(LENTES_PEL_MIS_CATALOGOS_REQUEST, obtenerFitrosFromDB),
    takeLatest(LENTES_PEL_FORMULARIO_INICIALIZAR, inicializarFormulario),
    takeLatest(LENTES_PEL_GET_ORDEN_GRADUACION_REQUEST, obtenerOrdenGraduacion),
    takeLatest(LENTES_PEL_GET_COLORES_REQUEST, obtenerColores),
    takeLatest(LENTES_PEL_GET_FABRICANTES_REQUEST, obtenerFabricantes),
    takeLatest(LENTES_PEL_GET_LENTESTIPOSPVP_REQUEST, obtenerLentesTiposPvps),
    takeLatest(LENTES_PEL_GET_PASILLOS_REQUEST, obtenerPasillos),
    takeLatest(LENTES_PEL_GET_INDICES_REQUEST, obtenerIndices),

    takeLatest(LENTES_PEL_PROCESS_FINAL_SELECTION, processLenteFinalSelection),
    takeLatest(LENTES_PEL_GET_DIAMETROS_POSIBLES_REQUEST, getDiametrosPosibles),
    takeLatest(LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_REQUEST, getTratamientosPosibles),
    takeLatest(LENTES_PEL_OBTENER_DATOS_LENTES, obtenerDatosLente),

    takeLatest([
      LENTES_PEL_GET_LENTES_LIST_REQUEST,
    ], getLentesList),

    takeLatest([
      LENTES_PEL_GET_COLORES_LENTE_REQUEST,
    ], getColoresLenteList),
    takeLatest([
      LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO,
    ], setTitleGw1),

    takeEvery([
      LENTES_PEL_SELECCION_GRADUACION,
      LENTES_PEL_SELECCION_GRADUACION_GENERICA,
      LENTES_PEL_SELECCION_COLOR,
      LENTES_PEL_SELECCION_FABRICANTE,
      LENTES_PEL_SET_DIAMETRO_MINIMO,
      LENTES_PEL_SELECCION_LENTE_TIPO_PVP,
      LENTES_PEL_SELECCION_PASILLO,
      LENTES_PEL_GET_INDICES_SUCCESS,
      LENTES_PEL_GET_PASILLOS_SUCCESS,
      LENTES_PEL_GET_COLORES_SUCCESS,
      LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS,
      LENTES_PEL_SET_FUERA_NORMA,
      LENTES_PEL_SELECCION_INDICE,
      LENTES_PEL_SET_SEARCH_VALUE,
    ], doLentesListRequest),
  ]);
}

export default pelSaga;
